// extracted by mini-css-extract-plugin
export default {"arrow":"style_arrow__zW9d0","up":"style_up__Ypbpa","down":"style_down__GWxjW"};